/**
 * Multilingual articles data
 * Contains all article metadata and slug mappings for i18n
 */

import { getArticleContent } from './articles-content';

export interface ArticleData {
  id: string;
  image: string;
  readingTime: number;
  publishedDate: string;
  author: string;
  relatedProducts: string[];
  slugs: Record<string, string>;
  titles: Record<string, string>;
  excerpts: Record<string, string>;
}

// Article database with all translations
export const articlesData: Record<string, ArticleData> = {
  'speedbox-review': {
    id: 'speedbox-review',
    image: '/images/blog/speedbox-3-bosch-recenzja.svg',
    readingTime: 8,
    publishedDate: '2025-01-15',
    author: 'BikeParkMapa Team',
    relatedProducts: ['speedbox-3-bosch'],
    slugs: {
      pl: 'speedbox-3-bosch-recenzja-2025',
      en: 'speedbox-3-bosch-review-2025',
      de: 'speedbox-3-bosch-bewertung-2025',
      cs: 'speedbox-3-bosch-recenze-2025',
      sk: 'speedbox-3-bosch-recenzia-2025',
      uk: 'speedbox-3-bosch-ohlyad-2025',
    },
    titles: {
      pl: 'SpeedBox 3.0 dla silnika e-bike Bosch - Szczera Recenzja 2025 [Test + Opinie]',
      en: 'SpeedBox 3.0 for Bosch E-bike Motor - Honest Review 2025 [Test + Opinions]',
      de: 'SpeedBox 3.0 für Bosch E-Bike Motor - Ehrliche Bewertung 2025 [Test + Meinungen]',
      cs: 'SpeedBox 3.0 pro motor e-bike Bosch - Upřímná Recenze 2025 [Test + Názory]',
      sk: 'SpeedBox 3.0 pre motor e-bike Bosch - Úprimná Recenzia 2025 [Test + Názory]',
      uk: 'SpeedBox 3.0 для мотора e-bike Bosch - Чесний Огляд 2025 [Тест + Думки]',
    },
    excerpts: {
      pl: '✅ Test SpeedBox 3.0 do silnika e-bike Bosch w 5 bikeparkach ✅ Realne wyniki prędkości (45+ km/h!) ✅ Montaż krok po kroku ✅ Ceny od 650 zł ✅ KUP TANIEJ na Amazon Prime →',
      en: '✅ SpeedBox 3.0 for Bosch e-bike motors tested in 5 bikeparks ✅ Real speed results (45+ km/h!) ✅ Step-by-step installation ✅ Prices from 650 PLN ✅ BUY CHEAPER on Amazon Prime →',
      de: '✅ SpeedBox 3.0 für Bosch E-Bike Motoren in 5 Bikeparks getestet ✅ Echte Geschwindigkeitsergebnisse (45+ km/h!) ✅ Installation Schritt für Schritt ✅ Preise ab 650 PLN ✅ GÜNSTIGER auf Amazon Prime →',
      cs: '✅ SpeedBox 3.0 pro motory e-bike Bosch testován v 5 bikeparcích ✅ Skutečné výsledky rychlosti (45+ km/h!) ✅ Instalace krok za krokem ✅ Ceny od 650 PLN ✅ KOUPIT LEVNĚJI na Amazon Prime →',
      sk: '✅ SpeedBox 3.0 pre motory e-bike Bosch testovaný v 5 bikeparkoch ✅ Skutočné výsledky rýchlosti (45+ km/h!) ✅ Inštalácia krok za krokom ✅ Ceny od 650 PLN ✅ KÚPIŤ LACNEJŠIE na Amazon Prime →',
      uk: '✅ SpeedBox 3.0 для моторів e-bike Bosch протестовано у 5 байкпарках ✅ Реальні результати швидкості (45+ км/год!) ✅ Встановлення крок за кроком ✅ Ціни від 650 злотих ✅ КУПИТИ ДЕШЕВШЕ на Amazon Prime →',
    },
  },
  'top-5-chips': {
    id: 'top-5-chips',
    image: '/images/blog/top-5-chipow-tuningowych.svg',
    readingTime: 12,
    publishedDate: '2025-01-25',
    author: 'BikeParkMapa Team',
    relatedProducts: ['speedbox-3-bosch'],
    slugs: {
      pl: 'top-5-chipow-tuningowych-e-bike-2025',
      en: 'top-5-tuning-chips-e-bike-2025',
      de: 'top-5-tuning-chips-e-bike-2025',
      cs: 'top-5-tuningovych-cipu-e-bike-2025',
      sk: 'top-5-tuningovych-cipov-e-bike-2025',
      uk: 'top-5-tyuning-chipiv-e-bike-2025',
    },
    titles: {
      pl: 'Top 5 chipów tuningowych e-bike 2025 - Ranking i Porównanie',
      en: 'Top 5 E-bike Tuning Chips 2025 - Ranking and Comparison',
      de: 'Top 5 E-Bike Tuning-Chips 2025 - Ranking und Vergleich',
      cs: 'Top 5 Tuningových Čipů pro E-bike 2025 - Žebříček a Srovnání',
      sk: 'Top 5 Tuningových Čipov pre E-bike 2025 - Rebríček a Porovnanie',
      uk: 'Топ 5 Тюнінг Чіпів для E-bike 2025 - Рейтинг та Порівняння',
    },
    excerpts: {
      pl: '🏆 Ranking 5 najlepszych chipów tuningowych 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Szczegółowe porównanie cen (499-849 zł) ✅ Test kompatybilności Bosch/Shimano ✅ Kup na Amazon →',
      en: '🏆 Top 5 tuning chips 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Detailed price comparison (499-849 PLN) ✅ Bosch/Shimano compatibility test ✅ Buy on Amazon →',
      de: '🏆 Top 5 Tuning-Chips 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Detaillierter Preisvergleich (499-849 PLN) ✅ Bosch/Shimano-Kompatibilitätstest ✅ Auf Amazon kaufen →',
      cs: '🏆 Top 5 tuningových čipů 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Podrobné srovnání cen (499-849 PLN) ✅ Test kompatibility Bosch/Shimano ✅ Koupit na Amazonu →',
      sk: '🏆 Top 5 tuningových čipov 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Podrobné porovnanie cien (499-849 PLN) ✅ Test kompatibility Bosch/Shimano ✅ Kúpiť na Amazone →',
      uk: '🏆 Топ 5 тюнінгових чіпів 2025 ✅ SpeedBox vs Badass vs PearTune ✅ Детальне порівняння цін (499-849 злотих) ✅ Тест сумісності Bosch/Shimano ✅ Купити на Amazon →',
    },
  },
  'tuning-worth-it': {
    id: 'tuning-worth-it',
    image: '/images/blog/tuning-e-bike-czy-warto.svg',
    readingTime: 10,
    publishedDate: '2025-01-20',
    author: 'BikeParkMapa Team',
    relatedProducts: ['speedbox-3-bosch'],
    slugs: {
      pl: 'tuning-e-bike-czy-warto-2025',
      en: 'ebike-tuning-worth-it-2025',
      de: 'ebike-tuning-lohnt-es-sich-2025',
      cs: 'ebike-tuning-stoji-to-za-to-2025',
      sk: 'ebike-tuning-stoji-to-za-to-2025',
      uk: 'ebike-tyuning-chy-varto-2025',
    },
    titles: {
      pl: 'Tuning e-bike 2026: czy warto? Koszty, mandaty, gwarancja',
      en: 'E-Bike Tuning 2026: Worth It? Real Costs, Risks, Warranty',
      de: 'E-Bike Tuning 2026 — Kosten, Garantie, Motor und Risiken',
      cs: 'Tuning e-bike 2026: Stojí to za to? Náklady, pokuty motoru',
      sk: 'Tuning e-bike 2026: Stojí to za to? Náklady, pokuty motora',
      uk: 'Тюнінг e-bike 2026 — чи варто? Штрафи і витрати на мотор',
    },
    excerpts: {
      pl: 'Tuning e-bike: realne koszty 600-1050 zł, ryzyko gwarancji, dane o zużyciu silnika. SpeedBox 3 vs Badass Box — szczere porównanie 2026 zanim wydasz złotówkę.',
      en: 'E-bike chip tuning unlocked: real cost (€150-260), warranty risks, motor wear data. Speedbox 3 vs Badass Box honest 2026 comparison — before you spend a cent.',
      de: 'E-Bike-Chiptuning entschlüsselt: echte Kosten (150-260€), Garantie-Risiken, Motorverschleiß-Daten. SpeedBox 3 vs Badass Box ehrlicher Vergleich 2026.',
      cs: 'Tuning e-bike: reálné náklady 3500-6000 Kč, riziko záruky, data o opotřebení motoru. SpeedBox 3 vs Badass Box — upřímné srovnání 2026 než utratíte korunu.',
      sk: 'Tuning e-bike: reálne náklady 150-260 €, riziko záruky, dáta o opotrebení motora. SpeedBox 3 vs Badass Box — úprimné porovnanie 2026 pred kúpou.',
      uk: 'Тюнінг e-bike: реальна ціна (600-1050 злотих), ризики гарантії, дані про знос мотора. SpeedBox 3 vs Badass Box — чесне порівняння 2026 перед покупкою.',
    },
  },
  'skok-widelca': {
    id: 'skok-widelca',
    image: '/images/blog/skok-widelca-mtb.svg',
    readingTime: 11,
    publishedDate: '2026-04-24',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'skok-widelca-mtb',
      en: 'mtb-fork-travel-guide',
      de: 'mtb-gabel-federweg-ratgeber',
      cs: 'zdvih-vidlice-mtb',
      sk: 'zdvih-vidlice-mtb',
      uk: 'khid-vylky-mtb',
    },
    titles: {
      pl: 'Skok widelca MTB - jaki wybrać? Kompletny poradnik 2026',
      en: 'MTB Fork Travel - Which to Choose? Complete 2026 Guide',
      de: 'MTB Gabel-Federweg - Welcher ist richtig? Ratgeber 2026',
      cs: 'Zdvih vidlice MTB - který vybrat? Kompletní průvodce 2026',
      sk: 'Zdvih vidlice MTB - ktorý vybrať? Kompletný sprievodca 2026',
      uk: 'Хід вилки MTB - який вибрати? Повний посібник 2026',
    },
    excerpts: {
      pl: 'Skok widelca MTB - 140mm, 150mm, 160mm czy 170mm? Kompletny poradnik: kiedy większy skok pomaga, a kiedy psuje rower. Charakterystyka sprężyny, geometria, case study ZEB vs Lyrik, checklist doboru.',
      en: 'MTB fork travel - 140mm, 150mm, 160mm or 170mm? Complete guide: when more travel helps and when it breaks your bike. Spring curve, geometry, ZEB vs Lyrik case study, selection checklist.',
      de: 'MTB Gabel-Federweg - 140mm, 150mm, 160mm oder 170mm? Kompletter Ratgeber: wann mehr Federweg hilft und wann er das Rad ruiniert. Federkennlinie, Geometrie, ZEB vs Lyrik Fallstudie, Checkliste.',
      cs: 'Zdvih vidlice MTB - 140mm, 150mm, 160mm nebo 170mm? Kompletní průvodce: kdy větší zdvih pomůže a kdy pokazí kolo. Charakteristika pružiny, geometrie, případová studie ZEB vs Lyrik, checklist.',
      sk: 'Zdvih vidlice MTB - 140mm, 150mm, 160mm alebo 170mm? Kompletný sprievodca: kedy väčší zdvih pomôže a kedy pokazí bicykel. Charakteristika pružiny, geometria, prípadová štúdia, checklist.',
      uk: 'Хід вилки MTB - 140мм, 150мм, 160мм чи 170мм? Повний посібник: коли більший хід допомагає, а коли псує велосипед. Характеристика пружини, геометрія, кейс ZEB vs Lyrik, чеклист.',
    },
  },
  'pierwszy-rower-dh-poradnik': {
    id: 'pierwszy-rower-dh-poradnik',
    image: '/images/blog/pierwszy-rower-dh-poradnik.svg',
    readingTime: 10,
    publishedDate: '2026-05-03',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'pierwszy-rower-dh-poradnik',
      en: 'first-downhill-bike-buying-guide',
      de: 'erstes-downhill-bike-kaufberatung',
      cs: 'prvni-dh-kolo-pruvodce',
      sk: 'prvy-dh-bicykel-pruvodca',
      uk: 'pershyi-dh-velosyped-posibnyk',
    },
    titles: {
      pl: 'Pierwszy rower DH — co kupić zaczynając zjazd 2026',
      en: 'First Downhill Bike — What to Buy When Starting DH 2026',
      de: 'Erstes Downhill-Bike — was kaufen für den Einstieg 2026',
      cs: 'První DH kolo — co koupit začínajícímu jezdci 2026',
      sk: 'Prvý DH bicykel — čo kúpiť na začiatok zjazdu 2026',
      uk: 'Перший велосипед DH — що купити для старту 2026',
    },
    excerpts: {
      pl: 'Pierwszy rower DH 2026 — kompletny poradnik. Enduro 160-170mm na start zamiast pełnokrwistego DH 200mm. Budżet 4-25k zł, 6 konkretnych modeli (Trek, Specialized, Canyon, Cube, YT, Commencal), czego unikać kupując pierwszy rower, kiedy przejść na czysty DH.',
      en: 'First downhill bike 2026 — full buying guide. Why enduro 160-170mm beats a full DH 200mm rig as your first bike. Budget 4-25k PLN brackets, 6 concrete models (Trek, Specialized, Canyon, Cube, YT, Commencal), what to avoid, when to upgrade to true DH.',
      de: 'Erstes Downhill-Bike 2026 — kompletter Kaufratgeber. Enduro 160-170mm statt 200mm DH zum Einstieg. Budget 4-25k PLN, 6 konkrete Modelle (Trek, Specialized, Canyon, Cube, YT, Commencal), was man vermeiden sollte, wann auf echtes DH wechseln.',
      cs: 'První DH kolo 2026 — kompletní průvodce nákupem. Enduro 160-170mm místo plnokrevného DH 200mm jako první kolo. Rozpočet 4-25k Kč, 6 konkrétních modelů, čeho se vyvarovat, kdy přejít na čisté DH.',
      sk: 'Prvý DH bicykel 2026 — kompletný sprievodca nákupom. Enduro 160-170mm namiesto plnohodnotného DH 200mm na začiatok. Rozpočet 4-25k €, 6 konkrétnych modelov, čomu sa vyhnúť, kedy prejsť na čisté DH.',
      uk: 'Перший велосипед DH 2026 — повний посібник з купівлі. Enduro 160-170мм замість повноцінного DH 200мм на старт. Бюджет, 6 конкретних моделей, чого уникати, коли переходити на справжній DH.',
    },
  },
  'wyciagi-rowerowe-beskidy-2026': {
    id: 'wyciagi-rowerowe-beskidy-2026',
    image: '/images/blog/wyciagi-rowerowe-beskidy-2026.svg',
    readingTime: 8,
    publishedDate: '2026-05-03',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'wyciagi-rowerowe-beskidy-2026',
      en: 'bike-lifts-beskidy-poland-2026',
      de: 'bike-lifte-beskiden-2026',
      cs: 'bike-vleky-beskydy-2026',
      sk: 'bike-vleky-beskydy-2026',
      uk: 'bike-pidiomnyky-beskydy-2026',
    },
    titles: {
      pl: 'Wyciągi rowerowe w Beskidach 2026 — lista, ceny, godziny',
      en: 'Bike Lifts in Beskidy Poland 2026 — List, Prices, Schedules',
      de: 'Bike-Lifte in den Beskiden 2026 — Liste, Preise, Öffnungszeiten',
      cs: 'Bike vleky v Beskydech 2026 — seznam, ceny, otevírací doba',
      sk: 'Bike vleky v Beskydách 2026 — zoznam, ceny, otváracie hodiny',
      uk: 'Підіймачі для велосипедів у Бескидах 2026 — список, ціни, години',
    },
    excerpts: {
      pl: 'Wyciągi rowerowe w Beskidach 2026 — pełna lista wyciągów dla rowerzystów (Szczyrk, Mosorny Groń, Wisła, Klimczok), ceny karnetów dziennych i pojedynczych przejazdów, godziny pracy, transport rowerów, wymogi techniczne.',
      en: 'Bike lifts in Poland\'s Beskidy 2026 — full list of cyclist-friendly lifts (Szczyrk, Mosorny Groń, Wisła, Klimczok), day pass prices, single rides, operating hours, bike transport, technical requirements.',
      de: 'Bike-Lifte in den polnischen Beskiden 2026 — vollständige Liste fahrradtauglicher Lifte (Szczyrk, Mosorny Groń, Wisła, Klimczok), Tageskartenpreise, Einzelfahrten, Betriebszeiten, Radtransport, Anforderungen.',
      cs: 'Bike vleky v polských Beskydech 2026 — kompletní seznam vleků pro cyklisty (Szczyrk, Mosorny Groń, Wisła, Klimczok), ceny denních jízdenek a jednotlivých jízd, otevírací doba, přeprava kol, technické požadavky.',
      sk: 'Bike vleky v poľských Beskydách 2026 — kompletný zoznam vlekov pre cyklistov (Szczyrk, Mosorny Groń, Wisła, Klimczok), ceny denných lístkov a jednotlivých jázd, otváracie hodiny, preprava bicyklov, technické požiadavky.',
      uk: 'Підіймачі для велосипедів у польських Бескидах 2026 — повний перелік (Щирк, Мосорний Ґронь, Вісла, Клімчок), ціни денних абонементів і одиничних поїздок, години роботи, транспортування велосипедів.',
    },
  },
  'beskidy-bikeparki-trasy-dh': {
    id: 'beskidy-bikeparki-trasy-dh',
    image: '/images/blog/beskidy-bikeparki-trasy-dh.svg',
    readingTime: 14,
    publishedDate: '2026-05-03',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'beskidy-bikeparki-trasy-dh',
      en: 'beskidy-bikeparks-downhill-trails-poland',
      de: 'beskiden-bikeparks-downhill-strecken',
      cs: 'beskydy-bikeparky-dh-trate',
      sk: 'beskydy-bikeparky-dh-trate',
      uk: 'beskydy-baikparky-trasy-dh',
    },
    titles: {
      pl: 'Beskidy MTB: bikeparki, trasy DH i wyciągi 2026 — przewodnik',
      en: 'Beskidy MTB: Bikeparks, DH Trails and Lifts 2026 — Guide',
      de: 'Beskiden MTB: Bikeparks, DH-Strecken und Lifte 2026 — Ratgeber',
      cs: 'Beskydy MTB: bikeparky, DH trate a vleky 2026 — průvodce',
      sk: 'Beskydy MTB: bikeparky, DH trate a vleky 2026 — sprievodca',
      uk: 'Бескиди MTB: байкпарки, траси DH і підіймачі 2026 — посібник',
    },
    excerpts: {
      pl: 'Beskidy MTB 2026 — kompletny przewodnik po regionie z największą koncentracją bikeparków w Polsce. Szczyrk, Mosorny Groń, Wisła Skolnity, Bielsko Enduro Trails, trasy DH poza bikeparkami, wyciągi rowerowe, baza noclegowa, logistyka wyjazdu.',
      en: 'Beskidy MTB 2026 — full guide to Poland\'s biggest cluster of bikeparks. Szczyrk, Mosorny Groń, Wisła Skolnity, Bielsko Enduro Trails, DH trails outside bikeparks, bike lifts, accommodation and trip logistics.',
      de: 'Beskiden MTB 2026 — umfassender Ratgeber zur Region mit Polens größter Bikepark-Konzentration. Szczyrk, Mosorny Groń, Wisła, Bielsko Enduro, DH-Strecken, Bike-Lifte, Unterkünfte und Reiseplanung.',
      cs: 'Beskydy MTB 2026 — kompletní průvodce regionem s největší koncentrací bikeparků v Polsku. Szczyrk, Mosorny Groń, Wisła Skolnity, Bielsko Enduro, DH trate mimo bikeparky, vleky, ubytování a logistika výjezdu.',
      sk: 'Beskydy MTB 2026 — kompletný sprievodca regiónom s najväčšou koncentráciou bikeparkov v Poľsku. Szczyrk, Mosorny Groń, Wisła, Bielsko Enduro, DH trate mimo bikeparkov, vleky, ubytovanie a logistika výjazdu.',
      uk: 'Бескиди MTB 2026 — повний посібник по регіону з найбільшою концентрацією байкпарків у Польщі. Щирк, Мосорний Ґронь, Вісла, Бельсько Ендуро, траси DH поза байкпарками, підіймачі, проживання, логістика поїздки.',
    },
  },
  'najlepsze-bikeparki-polska-2026': {
    id: 'najlepsze-bikeparki-polska-2026',
    image: '/images/blog/najlepsze-bikeparki-polska-2026.svg',
    readingTime: 12,
    publishedDate: '2026-05-03',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'najlepsze-bikeparki-polska-2026',
      en: 'best-bikeparks-poland-2026-ranking',
      de: 'beste-bikeparks-polen-2026',
      cs: 'nejlepsi-bikeparky-polsko-2026',
      sk: 'najlepsie-bikeparky-polsko-2026',
      uk: 'naykrashchi-baikparky-polshcha-2026',
    },
    titles: {
      pl: 'Najlepsze bikeparki w Polsce 2026 — ranking i porównanie',
      en: 'Best Bikeparks in Poland 2026 — Ranking and Comparison',
      de: 'Beste Bikeparks in Polen 2026 — Ranking und Vergleich',
      cs: 'Nejlepší bikeparky v Polsku 2026 — žebříček a srovnání',
      sk: 'Najlepšie bikeparky v Poľsku 2026 — rebríček a porovnanie',
      uk: 'Найкращі байкпарки у Польщі 2026 — рейтинг і порівняння',
    },
    excerpts: {
      pl: 'Ranking 15 najlepszych bikeparków w Polsce 2026 — Szczyrk, Białka, Czarna Góra, Mosorny Groń i kolejni. 6 kryteriów oceny, polecenia per kategoria (rodzina, DH, początkujący), orientacyjne ceny, mapa wszystkich obiektów.',
      en: 'Ranking of 15 best bikeparks in Poland for 2026 — Szczyrk, Białka, Czarna Góra, Mosorny Groń and more. 6 evaluation criteria, recommendations per category (family, DH, beginner), price ranges, full map of bikeparks.',
      de: 'Ranking der 15 besten Bikeparks in Polen 2026 — Szczyrk, Białka, Czarna Góra, Mosorny Groń und weitere. 6 Bewertungskriterien, Empfehlungen pro Kategorie (Familie, DH, Anfänger), Preisspannen, Bikepark-Karte.',
      cs: 'Žebříček 15 nejlepších bikeparků v Polsku 2026 — Szczyrk, Białka, Czarna Góra, Mosorny Groń a další. 6 hodnotících kritérií, doporučení podle kategorie (rodina, DH, začátečníci), orientační ceny, mapa bikeparků.',
      sk: 'Rebríček 15 najlepších bikeparkov v Poľsku 2026 — Szczyrk, Białka, Czarna Góra, Mosorny Groń a ďalšie. 6 hodnotiacich kritérií, odporúčania podľa kategórie (rodina, DH, začiatočníci), orientačné ceny, mapa bikeparkov.',
      uk: 'Рейтинг 15 найкращих байкпарків у Польщі 2026 — Щирк, Бялка, Чарна Гура, Мосорний Ґронь та інші. 6 критеріїв оцінки, рекомендації за категоріями (родина, DH, початківці), орієнтовні ціни, карта байкпарків.',
    },
  },
  'trasy-dh-poczatkujacy': {
    id: 'trasy-dh-poczatkujacy',
    image: '/images/blog/trasy-dh-poczatkujacy.svg',
    readingTime: 9,
    publishedDate: '2026-05-03',
    author: 'BikeParkMapa Team',
    relatedProducts: [],
    slugs: {
      pl: 'trasy-dh-dla-poczatkujacych',
      en: 'mtb-downhill-trails-for-beginners-poland',
      de: 'mtb-downhill-strecken-fuer-anfaenger-polen',
      cs: 'dh-trate-pro-zacatecniky-polsko',
      sk: 'dh-trate-pre-zaciatocnikov-polsko',
      uk: 'dh-trasy-dlya-pochatkivtsiv-polshcha',
    },
    titles: {
      pl: 'Trasy downhill dla początkujących w Polsce — gdzie zacząć w 2026',
      en: 'MTB Downhill Trails for Beginners in Poland — Where to Start in 2026',
      de: 'MTB Downhill-Strecken für Anfänger in Polen — wo 2026 starten',
      cs: 'DH trate pro začátečníky v Polsku — kde začít v 2026',
      sk: 'DH trate pre začiatočníkov v Poľsku — kde začať v 2026',
      uk: 'DH траси для початківців у Польщі — з чого почати у 2026',
    },
    excerpts: {
      pl: 'Trasy downhill dla początkujących w Polsce — 8 sprawdzonych miejsc, w których realnie da się zacząć. Skala trudności kolorów, sprzęt minimum, plan pierwszego dnia w bikeparku, lista typowych błędów i checklist gotowości.',
      en: 'MTB downhill trails for beginners in Poland — 8 places where you can actually start. Color difficulty scale, minimum gear, first-day-in-bikepark plan, common mistakes and a readiness checklist.',
      de: 'MTB Downhill-Strecken für Anfänger in Polen — 8 Orte, an denen man wirklich starten kann. Farbskala, Mindestausrüstung, Plan für den ersten Bikepark-Tag, typische Fehler und Checkliste.',
      cs: 'DH trate pro začátečníky v Polsku — 8 míst, kde můžete reálně začít. Stupnice obtížnosti, minimální výbava, plán prvního dne v bikeparku, časté chyby a checklist připravenosti.',
      sk: 'DH trate pre začiatočníkov v Poľsku — 8 miest, kde môžete reálne začať. Stupnica obtiažnosti, minimálna výbava, plán prvého dňa v bikeparku, časté chyby a checklist pripravenosti.',
      uk: 'DH траси для початківців у Польщі — 8 місць, де можна реально розпочати. Шкала складності, мінімальне спорядження, план першого дня у байкпарку, типові помилки та чекліст готовності.',
    },
  },
  'speedbox-vs-badass': {
    id: 'speedbox-vs-badass',
    image: '/images/blog/speedbox-vs-badass.svg',
    readingTime: 10,
    publishedDate: '2025-02-01',
    author: 'BikeParkMapa Team',
    relatedProducts: ['speedbox-3-bosch', 'badass-box-4'],
    slugs: {
      pl: 'speedbox-vs-badass-box-porownanie-2025',
      en: 'speedbox-vs-badass-box-comparison-2025',
      de: 'speedbox-vs-badass-box-vergleich-2025',
      cs: 'speedbox-vs-badass-box-srovnani-2025',
      sk: 'speedbox-vs-badass-box-porovnanie-2025',
      uk: 'speedbox-vs-badass-box-porivnyannya-2025',
    },
    titles: {
      pl: 'SpeedBox 3.0 vs Badass Box 4 dla silnika e-bike Bosch - Które wybrać? [Porównanie 2025]',
      en: 'SpeedBox 3.0 vs Badass Box 4 for Bosch E-bike Motor - Which to Choose? [Comparison 2025]',
      de: 'SpeedBox 3.0 vs Badass Box 4 für Bosch E-Bike Motor - Welches wählen? [Vergleich 2025]',
      cs: 'SpeedBox 3.0 vs Badass Box 4 pro motor e-bike Bosch - Který vybrat? [Srovnání 2025]',
      sk: 'SpeedBox 3.0 vs Badass Box 4 pre motor e-bike Bosch - Ktorý vybrať? [Porovnanie 2025]',
      uk: 'SpeedBox 3.0 vs Badass Box 4 для мотора e-bike Bosch - Який вибрати? [Порівняння 2025]',
    },
    excerpts: {
      pl: '🆚 SpeedBox vs Badass Box dla silnika e-bike Bosch - szczegółowe porównanie ✅ Test obu chipów w bikeparku ✅ Tabela różnic (cena, funkcje, wodoodporność) ✅ WERDYKT: który kupić? ✅ Amazon Prime →',
      en: '🆚 SpeedBox vs Badass Box for Bosch e-bike motors - detailed comparison ✅ Both chips tested in bikepark ✅ Difference table (price, features, waterproofing) ✅ VERDICT: which to buy? ✅ Amazon Prime →',
      de: '🆚 SpeedBox vs Badass Box für Bosch E-Bike Motoren - detaillierter Vergleich ✅ Beide Chips im Bikepark getestet ✅ Unterschiedstabelle (Preis, Funktionen, Wasserdichtigkeit) ✅ URTEIL: welchen kaufen? ✅ Amazon Prime →',
      cs: '🆚 SpeedBox vs Badass Box pro motory e-bike Bosch - podrobné srovnání ✅ Oba čipy testovány v bikeparku ✅ Tabulka rozdílů (cena, funkce, vodoodolnost) ✅ VERDIKT: který koupit? ✅ Amazon Prime →',
      sk: '🆚 SpeedBox vs Badass Box pre motory e-bike Bosch - podrobné porovnanie ✅ Oba čipy testované v bikeparku ✅ Tabuľka rozdielov (cena, funkcie, vodoodolnosť) ✅ VERDIKT: ktorý kúpiť? ✅ Amazon Prime →',
      uk: '🆚 SpeedBox vs Badass Box для моторів e-bike Bosch - детальне порівняння ✅ Обидва чіпи протестовані в байкпарку ✅ Таблиця відмінностей (ціна, функції, водонепроникність) ✅ ВЕРДИКТ: який купити? ✅ Amazon Prime →',
    },
  },
};

// Reverse mapping: slug -> article ID
const slugToArticleMap = new Map<string, string>();
Object.entries(articlesData).forEach(([id, data]) => {
  Object.values(data.slugs).forEach(slug => {
    slugToArticleMap.set(slug, id);
  });
});

// Get article by slug (works with any locale slug)
export function getArticleBySlug(slug: string): ArticleData | null {
  const articleId = slugToArticleMap.get(slug);
  return articleId ? articlesData[articleId] : null;
}

// Get article content with locale
export function getArticle(slug: string, locale: string) {
  const article = getArticleBySlug(slug);
  if (!article) return null;

  return {
    ...article,
    title: article.titles[locale] || article.titles.pl,
    excerpt: article.excerpts[locale] || article.excerpts.pl,
    slug: article.slugs[locale] || article.slugs.pl,
    content: getArticleContent(article.id, locale),
  };
}

// Get all article slugs for static generation
export function getAllArticleSlugs() {
  const slugs: string[] = [];
  Object.values(articlesData).forEach(article => {
    Object.values(article.slugs).forEach(slug => {
      slugs.push(slug);
    });
  });
  return slugs;
}
